import { z } from "zod";

import { dashboardWidgetLinks } from "../_dashboard-widget-link";

import { legend, thresholds, yAxis } from "./_sub-schemas";
import { timeSeriesQueries } from "./_time-series-query";

export const timeSeriesChartSchema = z
	.object({
		plugin: z.object({
			kind: z.literal("TimeSeriesChart"),
			spec: z
				.object({
					yAxis,
					legend,
					thresholds,
					visual: z
						.object({
							connectNulls: z.boolean().optional().catch(undefined),
						})
						.optional()
						.catch(undefined),
				})
				.catch({}),
		}),

		queries: timeSeriesQueries,

		links: dashboardWidgetLinks,
	})
	.transform(({ plugin, queries, links }) => ({ ...plugin, queries, links }));

export type TimeSeriesChart = z.infer<typeof timeSeriesChartSchema>;
